/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID } from "src/libs/utilities"
import { IDelimiterEdge } from "./Edge1"

export default function Edge24 (props: IDelimiterEdge): JSX.Element {
	const [id, ] = useState<ID>( getID("edge") )
		useEffect(() => {
			addCSSClass(
				`edge-${id}`,
				`.edge-${id} {
					${
						!!props.item.position
							?
							`width: ${getCssDemention(props.item.position?.width, "calc(100% + 120px)")}!important;
							height: ${getCssDemention(props.item.position?.height, "auto")}!important;
							z-index: ${props.item.position.z }!important;
							position: absolute;
							top:0;
							transform: translateX(${getCssDemention(props.item.position?.left, "-60px")})  translateY(${getCssDemention(props.item.position.top, "0")}) rotate(${ props.item.position.rotate|| 0 }deg) scale(${props.item.position.scale || 1})!important;
							`
							:
							``
					}
					.picto {
						height: ${getCssDemention(props.item.position?.height, "auto")}!important;
					}
				}`
			)
			return () => {
				removeCSSClass(`edge-${id}`)
			}
		},[])

	const fill: any = props.item.fill || "var(--force-contast-color)" 

	return <div className={`w-100 flex-centered edge-${id}`}>
		<svg 
			version="1.1" 
			xmlns="http://www.w3.org/2000/svg" 
			xmlnsXlink="http://www.w3.org/1999/xlink" 
			x="0px" 
			y="0px" 
			viewBox="0 0 500 48.9" 
			xmlSpace="preserve"
			className={`landing-delimiter-torn picto`}
		>  
			<g>
				<path fill={"#FFCC4D"} d="M193.5,14.3c-9.6-4-18.6,7-15.8,16.1c1,3.3,3.6,5.7,6.7,6.6c1.5,0.9,3.3,1.4,5.2,1.4c3.7,0,7.2-1.9,9.4-4.7
					C204,27.2,200.8,17.4,193.5,14.3z"/>
				<path fill={"#FFCC4D"} d="M219.9,17.5c-1.8-1.8-4.3-3-6.8-2.8c-1.8,0.1-3.5,0.4-5.1,1.3c-0.8,0.5-1.7,1.2-2.3,1.8
					c-1.3,1.4-2.4,3.2-2.9,5c-0.6,2.4-0.7,5.2,0.1,7.6c1.3,3.9,4.1,7.1,8.1,8.3c4.3,1.3,9-0.4,11.7-3.9c2.5-3.3,2.5-7.2,1.2-10.9
					C223.1,21.4,221.9,19.2,219.9,17.5z"/>
				<path fill={"#FFCC4D"} d="M312.2,26.4c-0.3-0.8-0.6-1.5-1-2.3c0-0.1-0.1-0.2-0.1-0.3c-0.3-0.4-0.5-0.7-0.8-1.1
					c-0.3-0.4-0.6-0.7-0.8-1.1c-0.7-0.8-1.6-1.4-2.5-1.9c-2.5-1.4-5.2-1.6-7.9-0.9c-0.8,0.3-1.5,0.6-2.3,1c-0.9,0.5-1.7,1.2-2.3,2
					c-1,0.9-1.8,1.9-2.4,3.1c-0.1-1.6-0.6-3.1-1.4-4.5c-2.5-4.4-8-6.5-12.8-5c-1.4,0.4-2.6,1.1-3.7,2c-2,1-3.7,2.8-4.7,4.6
					c-1.3,2.3-1.7,4.8-1.4,7.4c0.3,2.5,1.4,4.6,3.1,6.5c2,2.1,5.1,3.2,7.9,3.1c2.1,0,4.4-0.7,6.2-1.9c1.2-0.8,2.5-1.7,3.5-2.8
					c0.8-1,1.6-2,2.2-3.1c0.2,1.4,0.7,2.8,1.3,3.9c1.5,2.5,3.8,4.2,6.5,5c1.8,0.5,3.9,0.5,5.6,0c0.1,0,0.2-0.1,0.4-0.1
					c0.8-0.3,1.8-0.6,2.5-1.1c0.4-0.3,0.7-0.5,1.1-0.8c0.4-0.3,0.7-0.5,1.1-0.8c0.1-0.1,0.1-0.1,0.2-0.2c0.5-0.6,1-1.3,1.5-1.9
					c0.1-0.1,0.1-0.2,0.2-0.3c1-2,1-2,1.2-3.8c0.2-1.5,0.2-1.3,0-2.8C312.4,27.5,312.4,27,312.2,26.4z"/>
				<path fill={"#FFCC4D"} d="M132.7,23.9c-1.9-0.2-4,0.4-5.9,0.6c-2.6,0.3-3.1,3.5-0.6,4.5c2,0.8,4.3,1.7,6.5,1.5c1.8-0.1,3.3-1.4,3.3-3.3
					C136,25.2,134.5,24.1,132.7,23.9z"/>
				<path fill={"#FFCC4D"} d="M366.7,23c-1.2-0.5-2.2-1.3-3.5-1.6c-1.4-0.4-3-0.5-4.4-0.5c-3.3-0.1-5.8,3.1-5.4,6.2
					c0.5,3.3,3.6,5.3,6.9,4.6c1.2-0.3,2.4-0.7,3.5-1.2c1.1-0.5,2.1-1.4,2.9-2C368.5,27.4,369.1,24.1,366.7,23z"/>
			</g>
			<g>
				<path fill={"#FFCC4D"} d="M267,15.9c-1.4-2.7-5.7-2.5-8.2-2c-1.9,0.3-3.7,1.1-5.4,2.2c-0.2-2.8-0.3-5.7-0.6-8.5c-0.3-3.2-2.2-7.9-6.3-6
					c-2.9,1.3-4.3,5.9-5.4,8.6c-0.8,2.2-1.5,4.5-1.9,6.9c-2.4-1.3-4.9-2.3-7.5-2.8c-2.7-0.6-7.5-1.5-8.8,1.7c-1.2,2.8,2.3,6,4.1,7.7
					c0.4,0.4,0.8,0.8,1.3,1.1c1.7,1.6,3.6,3.1,5.7,4.2c-1.8,1.7-3.5,3.5-4.8,5.6c-1.5,2.5-4.5,7.6-1.3,9.9c3,2.1,7.4-0.2,9.8-2.1
					c2.7-2.2,5.2-5,7.5-7.6c0.5,0.6,1,1.2,1.5,1.8c1.1,1.3,2.2,2.6,3.2,4c1.8,2.6,4.8,7,8.4,6.5c4.6-0.6,4.3-6.5,3.1-9.7
					c-1.2-3.1-2.6-6.3-4.2-9.3c0.5-0.4,1-0.8,1.4-1.2c1.4-1.1,2.7-2.2,4-3.4C264.7,21.8,268.6,19,267,15.9z"/>
				<g>
					<path  fill={fill}  d="M341.2,17.1c-1.2,0-2.4,0.7-3.5,1.2c-1.3,0.6-2.6,1.2-3.9,1.9c-0.1-1-0.2-2-0.4-2.9c-0.2-1.3-0.5-2.6-1-3.8
						c-0.4-1.2-0.9-2.7-1.7-3.6c-1-1-2.7-0.9-3.5,0.3c-0.7,1.1-1.2,2.5-1.5,3.7c-0.5,1.9-0.7,3.9-0.9,5.8c-1.4-0.9-2.9-1.6-4.3-2.2
						c-1.7-0.7-4.6-2.2-6.3-0.9c-2,1.5,0.1,4.5,1.2,5.9c1.4,1.9,3.2,3.4,4.7,5.2c0.2,0.2,0.4,0.4,0.7,0.5c-0.7,2.9-1.1,5.8-1.4,8.7
						c-0.4,1.7-0.4,3.6,1.2,4.5c2.5,1.5,4.7-2,6-3.6c1.3-1.7,2.4-3.5,3.5-5.3c1.2,1.1,2.4,2.1,3.6,3.2c1.5,1.3,3.7,3.6,5.9,2
						c1.9-1.4,0.3-4.5-0.4-6.2c-0.7-1.6-1.5-3.1-2.4-4.6c1-0.7,2-1.4,3-2.2c0.9-0.8,1.7-1.6,2.4-2.5c0.7-0.8,1.6-1.8,1.6-2.9
						C343.7,17.9,342.5,17,341.2,17.1z"/>
					<path fill={fill} d="M310.6,25.4c-0.6-0.3-1.2-0.3-1.9-0.3c-0.7,0-1.4-0.1-2.1-0.1c-0.8,0-1.5,0-2.3,0c0.8-1,1.5-2.1,2.2-3.2
						c0.5-0.8-0.7-1.8-1.4-1.1c-0.8,1-1.8,2-2.8,2.8c-0.1-0.4-0.1-0.9-0.2-1.3c-0.1-1.3-0.2-2.5-0.2-3.8c0-1-1.6-1.3-1.8-0.2
						c-0.2,1.3-0.4,2.6-0.5,3.9c0,0.1,0,0.2,0,0.3c-0.7-0.8-1.3-1.5-2-2.3c-0.7-0.9-2,0.2-1.5,1.2c0.5,0.9,1,1.8,1.5,2.8c0,0,0,0,0,0
						c-0.3,0-0.6,0-0.9,0c-1.1-0.1-2.4-0.3-3.5,0c-0.7,0.2-0.9,1.3-0.2,1.6c1,0.5,2.3,0.5,3.4,0.7c0,0,0,0,0,0c-0.4,0.2-0.7,0.4-1,0.6
						c-0.9,0.6-1.9,1.2-2.5,2c-0.4,0.6,0.1,1.6,0.8,1.5c1-0.1,2-0.6,2.9-1c0.3-0.1,0.6-0.2,0.9-0.3c-0.1,0.2-0.2,0.4-0.3,0.6
						c-0.7,1.2-1.7,2.2-2.3,3.5c-0.5,1.2,1,2.2,1.8,1.1c0.8-1.2,2-2.1,2.9-3.2c0.2-0.2,0.4-0.5,0.6-0.7c0,0.2,0,0.3,0,0.5
						c0,0.9-0.1,2,0.3,2.8c0.2,0.5,1.1,0.5,1.3,0c0.4-0.8,0.3-1.8,0.4-2.7c0.1-0.4,0.1-0.7,0.2-1.1c0.1,0.2,0.3,0.4,0.4,0.6
						c0.9,1.1,1.9,2.2,2.9,3.2c0.6,0.7,1.6-0.2,1.2-0.9c-0.7-1.3-1.4-2.8-2.2-4.1c0,0,0,0,0,0c0.8,0.5,1.6,1,2.5,1.3
						c0.7,0.3,1.1-0.7,0.7-1.2c-0.6-0.6-1.4-1.1-2.1-1.7c0.2,0,0.4,0,0.6-0.1c0.7-0.1,1.4-0.2,2.1-0.2c0.6-0.1,1.3,0,1.9-0.4
						C311,26.4,311.1,25.7,310.6,25.4z"/>
					<path fill={fill} d="M286.4,25.5c-1.2-0.3-2.5-0.3-3.7-0.4c-0.4,0-0.8-0.1-1.3-0.1c1-1.1,1.9-2.2,2.9-3.2
						c0.5-0.5-0.2-1.6-0.8-1.1c-1.4,1-2.8,2-4.1,3.1c0.1-1.6,0.2-3.2,0.2-4.7c0-0.8-1.3-1-1.4-0.2c-0.2,1.2-0.5,2.5-0.7,3.7
						c-0.6-1.3-1.3-2.6-2-3.8c-0.4-0.7-1.7-0.2-1.4,0.6c0.5,1.4,1,2.9,1.4,4.4c-0.6-0.2-1.2-0.3-1.7-0.5c-0.6-0.2-1.2-0.3-1.9-0.5
						c-0.6-0.1-1.2-0.4-1.8-0.3c-0.6,0.1-1.2,0.9-0.6,1.4c0.5,0.4,1.2,0.6,1.8,0.9c0.6,0.2,1.1,0.4,1.7,0.7c0.1,0.1,0.3,0.1,0.4,0.2
						c-0.7,0.1-1.4,0.2-2.1,0.4c-0.7,0.1-1.4,0.3-2,0.5c-0.8,0.4-0.3,1.5,0.4,1.6c0.7,0,1.4-0.1,2-0.2c0.6-0.1,1.3-0.1,1.9-0.2
						c0.1,0,0.3,0,0.4,0c-0.3,0.2-0.5,0.3-0.8,0.5c-1.3,0.8-2.3,2-3.5,2.9c-0.8,0.6,0.2,1.8,1,1.3c1.3-0.8,2.4-1.8,3.8-2.4
						c0.4-0.2,0.8-0.4,1.1-0.6c-0.1,0.5-0.2,1.1-0.3,1.6c-0.1,0.5-0.2,1-0.4,1.5c-0.1,0.5-0.3,1-0.3,1.6c0,0.8,1,1,1.5,0.4
						c0.3-0.4,0.4-1,0.6-1.5c0.2-0.5,0.3-0.9,0.5-1.4c0.2-0.5,0.4-1.2,0.6-1.8c0.7,1.4,1.3,2.9,2,4.3c0.4,0.7,1.3,0.2,1.2-0.5
						c-0.2-1.5-0.7-3-1.2-4.5c0.2,0.2,0.5,0.4,0.7,0.6c0.4,0.4,0.9,0.7,1.3,1c0.5,0.3,0.9,0.7,1.5,0.7c0.4,0,0.6-0.4,0.5-0.7
						c-0.1-0.5-0.6-0.9-1-1.3c-0.4-0.4-0.8-0.8-1.2-1.2c-0.4-0.4-0.8-0.8-1.2-1.2c0,0,0,0,0,0c0.6,0,1.3,0.1,1.9,0.1
						c1.2,0,2.5,0.2,3.7,0.1C287,26.9,287.3,25.7,286.4,25.5z"/>
					<path fill={fill} d="M358.8,25c-0.6-2.5-3.1-4.4-5.7-4.4c-2.6,0-4.8,1.8-5.6,4.2c-0.6,2-0.2,4.2,1,5.8c1.8,2.4,5.1,3.1,7.6,1.2
						c0.8-0.6,1.4-1.4,1.8-2.2C358.9,28.4,359.2,26.6,358.8,25z M350.5,26.4C350.5,26.4,350.5,26.4,350.5,26.4c0,0.2,0.1,0.3,0.1,0.5
						C350.6,26.8,350.5,26.6,350.5,26.4z"/>
					<path fill={fill} d="M175.8,16.5c-1.7-1.3-4.6,0.2-6.3,0.9c-1.4,0.6-3,1.3-4.3,2.2c-0.2-2-0.4-3.9-0.9-5.8
						c-0.3-1.2-0.8-2.7-1.5-3.7c-0.8-1.2-2.5-1.3-3.5-0.3c-0.9,0.9-1.3,2.4-1.7,3.6c-0.4,1.3-0.8,2.5-1,3.8c-0.2,1-0.3,2-0.4,2.9
						c-1.2-0.7-2.5-1.3-3.9-1.9c-1.1-0.5-2.3-1.1-3.5-1.2c-1.3,0-2.5,0.8-2.5,2.2c0,1.1,0.9,2.1,1.6,2.9c0.7,0.9,1.5,1.7,2.4,2.5
						c0.9,0.8,1.9,1.5,3,2.2c-0.9,1.5-1.7,3-2.4,4.6c-0.8,1.6-2.3,4.7-0.4,6.2c2.1,1.6,4.3-0.6,5.9-2c1.2-1.1,2.4-2.1,3.6-3.2
						c1.1,1.8,2.2,3.6,3.5,5.3c1.3,1.7,3.5,5.2,6,3.6c1.6-1,1.6-2.8,1.2-4.5c-0.3-2.9-0.7-5.8-1.4-8.7c0.3-0.1,0.5-0.3,0.7-0.5
						c1.5-1.8,3.3-3.3,4.7-5.2C175.7,21,177.8,18,175.8,16.5z"/>
					<path fill={fill} d="M196.9,25.8c0.7-0.3,0.5-1.5-0.2-1.6c-1.1-0.3-2.4,0-3.5,0c-0.3,0-0.6,0-0.9,0c0,0,0,0,0,0
						c0.5-0.9,1-1.8,1.5-2.8c0.5-0.9-0.8-2-1.5-1.2c-0.7,0.8-1.3,1.5-2,2.3c0-0.1,0-0.2,0-0.3c-0.1-1.3-0.3-2.6-0.5-3.9
						c-0.2-1-1.7-0.7-1.8,0.2c0,1.3-0.1,2.5-0.2,3.8c0,0.4-0.1,0.8-0.2,1.3c-1-0.9-1.9-1.8-2.8-2.8c-0.6-0.8-1.9,0.2-1.4,1.1
						c0.7,1.1,1.4,2.2,2.2,3.2c-0.8,0-1.5,0-2.3,0c-0.7,0-1.4,0.1-2.1,0.1c-0.7,0-1.3,0-1.9,0.3c-0.5,0.3-0.5,1,0,1.3
						c0.5,0.4,1.2,0.3,1.9,0.4c0.7,0.1,1.4,0.2,2.1,0.2c0.2,0,0.4,0,0.6,0.1c-0.7,0.5-1.5,1-2.1,1.7c-0.5,0.5,0,1.4,0.7,1.2
						c0.9-0.3,1.7-0.8,2.5-1.3c0,0,0,0,0,0c-0.8,1.3-1.5,2.7-2.2,4.1c-0.4,0.7,0.6,1.6,1.2,0.9c1-1.1,2-2.1,2.9-3.2
						c0.2-0.2,0.3-0.4,0.4-0.6c0.1,0.4,0.1,0.7,0.2,1.1c0.1,0.9,0,1.9,0.4,2.7c0.2,0.5,1.1,0.5,1.3,0c0.4-0.9,0.2-1.9,0.3-2.8
						c0-0.2,0-0.3,0-0.5c0.2,0.3,0.4,0.5,0.6,0.7c0.9,1.1,2.1,2,2.9,3.2c0.8,1.1,2.3,0.2,1.8-1.1c-0.6-1.3-1.5-2.3-2.3-3.5
						c-0.1-0.2-0.2-0.4-0.3-0.6c0.3,0.1,0.6,0.2,0.9,0.3c0.9,0.3,1.9,0.9,2.9,1c0.7,0.1,1.3-0.9,0.8-1.5c-0.6-0.9-1.7-1.5-2.5-2
						c-0.3-0.2-0.7-0.4-1-0.6c0,0,0,0,0,0C194.6,26.3,195.8,26.2,196.9,25.8z"/>
					<path fill={fill} d="M220.5,26.4c-0.6-0.3-1.3-0.4-2-0.5c-0.7-0.2-1.4-0.3-2.1-0.4c0.1-0.1,0.3-0.1,0.4-0.2
						c0.6-0.2,1.1-0.4,1.7-0.7c0.6-0.2,1.3-0.4,1.8-0.9c0.6-0.5,0.1-1.3-0.6-1.4c-0.6-0.1-1.2,0.2-1.8,0.3c-0.6,0.2-1.3,0.3-1.9,0.5
						c-0.6,0.2-1.2,0.3-1.7,0.5c0.5-1.5,0.9-2.9,1.4-4.4c0.3-0.8-1-1.3-1.4-0.6c-0.7,1.2-1.4,2.5-2,3.8c-0.2-1.2-0.4-2.5-0.7-3.7
						c-0.2-0.8-1.5-0.6-1.4,0.2c0.1,1.6,0.1,3.2,0.2,4.7c-1.3-1.1-2.7-2.1-4.1-3.1c-0.7-0.5-1.4,0.5-0.8,1.1c1,1,1.9,2.1,2.9,3.2
						c-0.4,0-0.8,0.1-1.3,0.1c-1.2,0.1-2.5,0.2-3.7,0.4c-0.9,0.2-0.6,1.4,0.2,1.5c1.2,0.1,2.5,0,3.7-0.1c0.6,0,1.3-0.1,1.9-0.1
						c0,0,0,0,0,0c-0.4,0.4-0.8,0.8-1.2,1.2c-0.4,0.4-0.8,0.8-1.2,1.2c-0.4,0.4-0.9,0.8-1,1.3c-0.1,0.3,0.2,0.7,0.5,0.7
						c0.6,0,1-0.4,1.5-0.7c0.5-0.3,0.9-0.7,1.3-1c0.2-0.2,0.5-0.4,0.7-0.6c-0.5,1.5-1,3-1.2,4.5c-0.1,0.7,0.8,1.2,1.2,0.5
						c0.7-1.4,1.4-2.8,2-4.3c0.2,0.6,0.4,1.2,0.6,1.8c0.2,0.5,0.3,0.9,0.5,1.4c0.2,0.5,0.3,1.1,0.6,1.5c0.5,0.6,1.4,0.4,1.5-0.4
						c0-0.5-0.2-1.1-0.3-1.6c-0.1-0.5-0.2-1-0.4-1.5c-0.1-0.5-0.2-1-0.3-1.6c0.4,0.2,0.7,0.4,1.1,0.6c1.3,0.7,2.5,1.7,3.8,2.4
						c0.8,0.5,1.8-0.7,1-1.3c-1.2-0.9-2.2-2.1-3.5-2.9c-0.3-0.2-0.5-0.3-0.8-0.5c0.1,0,0.3,0,0.4,0c0.6,0,1.3,0.1,1.9,0.2
						c0.7,0.1,1.4,0.2,2,0.2C220.9,27.9,221.3,26.8,220.5,26.4z"/>
					<path fill={fill} d="M136.9,20.6c-2.6,0-5.1,1.9-5.7,4.4c-0.4,1.6-0.1,3.3,0.8,4.7c0.4,0.8,1,1.6,1.8,2.2
						c2.5,1.9,5.8,1.2,7.6-1.2c1.2-1.6,1.7-3.9,1-5.8C141.7,22.4,139.5,20.6,136.9,20.6z M139.5,27c0-0.2,0-0.4,0.1-0.5c0,0,0,0,0,0
						C139.5,26.6,139.5,26.8,139.5,27z"/>
				</g>
			</g>
		</svg>
	</div>
}

